// import global stylesheet
function initGlobalStyles() {
	// eslint-disable-next-line no-unused-expressions
	import('./global.css');
}

export { initGlobalStyles };
export { oldRsTheme, appTheme } from './oldRsTheme';
export * from './remoteSocialTheme';
